module.exports = __webpack_public_path__ + "img/advert.594f55ef.svg";